const crlReasons =
    {
        es: [
            {code:0, name: "No especificado"},
            {code:1, name: "Compromiso de la llave"},
            {code:2, name: "Compromiso de la CA"},
            {code:3, name: "Cambio de afiliación"},
            {code:4, name: "Reemplazado"},
            {code:5, name: "Cesación de Operación"},
            {code:6, name: "Certificado en espera"}
        ],
        en: [
            {code:0, name: "Not specified"},
            {code:1, name: "Key Compromise"},
            {code:2, name: "CA Compromise"},
            {code:3, name: "Change of affiliation"},
            {code:4, name: "Superseded"},
            {code:5, name: "Cease of operation"},
            {code:6, name: "Certificate Hold"}
        ]
    }
export default crlReasons;